// Modules
import { createSelector } from '@ngrx/store';

// Store - Reducers
import { getModuleState } from '@accidents/store/reducers';
import * as AccidentDetail from '@accidents/store/reducers/detail-accident.reducer';

export const selectDetailAccidentState = createSelector(
  getModuleState,
  state => state.detailAccident
);

export const selectDetailAccident = createSelector(
  selectDetailAccidentState,
  (state: AccidentDetail.AccidentDetailState) => state.accident
);

export const selectDetailAccidentLoading = createSelector(
  selectDetailAccidentState,
  (state: AccidentDetail.AccidentDetailState) => state.loadingAccident
);
